import { DEX_TYPE } from '@/config/constants'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

export const useBuildex = () => {
  const { dex } = getEnvAndDex()
  return dex === DEX_TYPE.SGBUILDEX
}
